import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import FieldConfig from "../../../proto/field-config"
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import {ConditionType_Excludes, ConditionType_Includes} from "../../../../model2/conditions/condition-types"
import {SortDirection} from "../../../../data-structures/sort"
import FieldExpenseReimbursement_ViewSmall from "./render/view-small";
import FieldExpenseReimbursement_InlineEditable from "./render/inline-editable";
import FieldProto_GlistGroupModern from "./components/glist-group/modern";
import FieldDropdown_GlistGroupStandard from "./components/glist-group/standard";
import FieldExpenseReimbursement_ConditionForm from "./render/condition"
import {ExpenseReimbursementStatus} from "../../../../model2/expenses/@types";
import {ColorPalette} from "../../../color-coding/color-coding";
import FieldStatus_PopoverOption from "../../../generic/status/components/popover/option";
import {ExpenseReimbursementStatusOptions} from "../../../../model2/expenses/@const";

// const debug = "FieldExpenseReimbursement"
const debug = false

export default class FieldExpenseReimbursement extends FieldDropdown {

    FIELD_DEFAULT_WIDTH = 150

    constructor(config:FieldConfig) {
        super(config)

        this.conditionTypes     = [ConditionType_Includes, ConditionType_Excludes]

        this.typeLabel          = "Reimbursement"
        this.filterType         = null
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Reimbursement field"
        this.colorPalette       = ColorPalette.STATUS

        this.icon               = ' ii5-credit-card';

        this.groupByDefaultSortDirection    = SortDirection.ASC

        this.options            = ExpenseReimbursementStatusOptions

        // Disable menu edit options
        this.showMenuMore                   = false
        this.components.PopoverMenuMore     = null

        this.components.PopoverOption       = FieldStatus_PopoverOption
        this.components.glistGroupModern    = FieldProto_GlistGroupModern
        this.components.glistGroupStandard  = FieldDropdown_GlistGroupStandard

        // remove default please select option
        this.noValueOption  = false

        this.renderComponents.inlineEditable    = FieldExpenseReimbursement_InlineEditable
        this.renderComponents.view              = FieldExpenseReimbursement_ViewSmall
        this.renderComponents.glistView         = FieldExpenseReimbursement_ViewSmall
        this.renderComponents.conditionForm     = FieldExpenseReimbursement_ConditionForm
    }
}
